import { store } from '../redux/store'
import * as React from 'react';
import { Component } from 'react';
import { useParams } from 'react-router-dom';
import { setToken } from '../redux/authSlice'
import { Navigate } from 'react-router-dom'

function withRouter(Component) {
    function ComponentWithRouter(props) {
        let params = useParams()
        return <Component {...props} params={params} />
    }
    return ComponentWithRouter
}

class SaveToken extends Component {

    componentDidMount() {
        let token = this.props.params.token
        store.dispatch(setToken(token))
    }

    render() {
        return (
            <Navigate to="/login" />
        );
    }
}

export default withRouter(SaveToken);